import { render, staticRenderFns } from "./PreferencesEditComponent.vue?vue&type=template&id=a81d7010&scoped=true&"
import script from "./PreferencesEditComponent.vue?vue&type=script&lang=js&"
export * from "./PreferencesEditComponent.vue?vue&type=script&lang=js&"
import style0 from "./PreferencesEditComponent.vue?vue&type=style&index=0&id=a81d7010&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a81d7010",
  null
  
)

export default component.exports